import axios from '@axios'

const PREFIX = 'interno/portal'

export default {
  source: null,
  CancelToken: null,

  getCobrancas(filtros) {
    return axios.post(`${PREFIX}`, filtros)
  },
  getHistoricos(id) {
    return axios.get(`${PREFIX}/${id}/historicos`)
  },
  homologar(id, homologado, justificativa) {
    return axios.get(`${PREFIX}/${id}?homologar=${homologado}&justificativa=${justificativa}`)
  },
  getURLDocumento(id) {
    return axios.get(`${PREFIX}/${id}/url`)
  },
  getFiltrosIniciais() {
    return axios.get(`${PREFIX}/filtros-iniciais`)
  },
  enviar(filtros, tokenCancel) {
    this.source = tokenCancel.source()
    this.CancelToken = tokenCancel
    return axios.post(`${PREFIX}/documento-manual`, filtros, { cancelToken: this.source.token })
  },
  dispensarDocumentos(filtros, tokenCancel) {
    this.source = tokenCancel.source()
    this.CancelToken = tokenCancel
    return axios.post(`${PREFIX}/dispensa-documento`, filtros, { cancelToken: this.source.token })
  },
  baixaEmLote(filtros, tokenCancel) {
    this.source = tokenCancel.source()
    this.CancelToken = tokenCancel
    return axios.post(`${PREFIX}/baixa-lote`, filtros, { cancelToken: this.source.token })
  },
  gerarCobrancaManua(filtros, tokenCancel) {
    this.source = tokenCancel.source()
    this.CancelToken = tokenCancel
    return axios.post(`${PREFIX}/cobranca-manual`, filtros, { cancelToken: this.source.token })
  },
  homologarEmLote(filtros, tokenCancel) {
    this.source = tokenCancel.source()
    this.CancelToken = tokenCancel
    return axios.post(`${PREFIX}/homologacao-lote`, filtros, { cancelToken: this.source.token })
  },
  cancelarEnvio() {
    this.source.cancel()
  },
}
